import mixpanel from 'mixpanel-browser';

const debug = false;

let isLocalhost =
  window.origin.includes('localhost') || window.origin.includes('gitpod');

if (debug) {
  isLocalhost = false;
}

mixpanel.init(process.env.MIXPANEL_TOKEN, {
  debug: debug,
  verbose: debug,
  api_host: `https://${process.env.MIXPANEL_API_HOST}`,
  batch_requests: true,
});

export { mixpanel, debug, isLocalhost };
